import React from "react";
import { Col, Row } from "react-bootstrap";

export const TwoColumnSection = ({
  firstColumn,
  secondColumn,
  mainSectionClass = "",
  ...props
}) => {
  return (
    <Row className={`g-4 ${mainSectionClass}`}>
      {firstColumn && <Col md={6}>{firstColumn}</Col>}
      {secondColumn && <Col md={6}>{secondColumn}</Col>}
    </Row>
  );
};
